import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './footer.css';
import { getProp } from '../../../ui/src/utilities';
import { CsmArticleContent } from '../../../ui/src/component/csmArticle';
import CsmSectionLink from '../csmSectionLink/csmSectionLink';
import { Icon } from '../../../ui/src/component/icon';

const Footer = props => {
  const renderCookies = () => {
    return (
      <li
        style={{
          fontSize: '15px !important',
        }}
      >
        <button
          type="button"
          onClick={() => {
            if (window && window.CookieConsentApi) {
              window.CookieConsentApi.showSettings();
            }
          }}
          style={{
            color: '#333',
            display: 'inline-block',
            border: '0',
            background: 'transparent',
            padding: '10px',
          }}
        >
          Nastavenia cookies
        </button>
      </li>
    );
  };


  return (
    <footer id="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-8 footer-nav">
            <ul>
              {getProp(props, 'nav', []).map((item) => {
                const isTerms = item.name === 'Ochrana osobných údajov';
                return (
                  <React.Fragment key={item._id}>
                    <li style={{ fontSize: '15px !important' }}>
                      <CsmSectionLink
                        target={props.linksTarget ? props.linksTarget : null}
                        section={item}
                      />
                    </li>
                    {isTerms && renderCookies()}
                  </React.Fragment>
                );
              })}

            </ul>
          </div>
          <div className="col-md-4 footer-copy">
            <div className="social">
              <a href={props.facebookUrl} target="_blank">
                <Icon name="facebook" className="fill-bg-alt-dark" />
              </a>
              {/*<a href="#" target="_blank">
                            <Icon name="instagram" className="fill-bg-alt-dark" />
                        </a>*/}
              <a href="" target="_blank">
                <Icon name="twitter" className="fill-bg-alt-dark" />
              </a>
            </div>
            {props.copyrightText}
          </div>
        </div>
        <hr />
        {props.content ? (
          <CsmArticleContent bottomGutter={false} content={props.content} />
        ) : null}
        {props.weatherCredit && (
          <div className="text-center weather-credit">
            {props.weatherCredit.data && (
              <a href={props.weatherCredit.data.url} target="_blank">
                {props.weatherCredit.data.text}
              </a>
            )}
          </div>
        )}
        <br />
        <div className="text-center">
          <a
            href="https://itunes.apple.com/sk/app/ko%C5%A1ice/id1225729882?mt=8"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              overflow: 'hidden',
              background:
                'url(//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat',
              width: '153px',
              height: '45px',
              backgroundSize: 'contain',
              verticalAlign: 'middle',
              margin: '0 5px',
            }}
          >{null}</a>
          {(() => {
            let shouldShow = true;
            if (typeof window !== 'undefined') {
              var chrome = window.navigator.userAgent.indexOf('Chrome') > -1;
              // var explorer = window.navigator.userAgent.indexOf('MSIE') > -1;
              // var firefox  = window.navigator.userAgent.indexOf('Firefox') > -1;
              var safari = window.navigator.userAgent.indexOf('Safari') > -1;
              // var camino   = window.navigator.userAgent.indexOf("Camino") > -1;
              // var opera    = window.navigator.userAgent.toLowerCase().indexOf("op") > -1;
              if (chrome && safari) safari = false;
              // if ((chrome) && (opera)) chrome = false;
              shouldShow = !safari;
            }
            // vzdy sa zobrazi logo
            shouldShow = true;
            if (shouldShow) {
              return (
                <a
                  href="https://play.google.com/store/apps/details?id=sk.markmedia.kosiceonline"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    overflow: 'hidden',
                    background:
                      'url(//data.tvkosice.sk/static/play-store-badge_new.png) no-repeat',
                    width: '153px',
                    height: '45px',
                    backgroundSize: 'contain',
                    verticalAlign: 'middle',
                    margin: '0 5px',
                  }}
                >{null}</a>
              );
            }
            return null;
          })()}
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  facebookUrl: 'https://www.facebook.com/kosiceonline/',
};

Footer.propTypes = {
  copyrightText: PropTypes.string,
  nav: PropTypes.array.isRequired,
  content: PropTypes.object,
  linksTarget: PropTypes.string,
  weatherCredit: PropTypes.object,
  facebookUrl: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    weatherCredit: state.weatherCredit,
  };
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/app/component/footer/footer.js